'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { AnalyticsProvider as AnalyticsContextProvider, useInitializeAnalytics } from '@/lib/analytics/analytics';
type AnalyticsProviderProps = {
  readonly children: React.ReactNode;
  readonly amplitudeApiKey?: string;
};
export function AnalyticsProvider(t0) {
  const $ = _c(5);
  const {
    children,
    amplitudeApiKey
  } = t0;
  let t1;
  if ($[0] !== amplitudeApiKey) {
    t1 = {
      amplitudeApiKey
    };
    $[0] = amplitudeApiKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const analytics = useInitializeAnalytics(t1);
  let t2;
  if ($[2] !== analytics || $[3] !== children) {
    t2 = <AnalyticsContextProvider value={analytics}>{children}</AnalyticsContextProvider>;
    $[2] = analytics;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}